module.exports = __webpack_public_path__ + "media/images/banner/tjt/pc/travel01_770_280_zh-hant-9954efb6e06ad1dfc4094dfe3629adf4.jpg";